import { render, staticRenderFns } from "./NoteType.vue?vue&type=template&id=0c590f8e&"
import script from "./NoteType.vue?vue&type=script&lang=js&"
export * from "./NoteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports